<div class="flex min-h-screen bg-amber-400">
  <!-- Left side - Image/Banner -->
  <div
    class="hidden md:flex md:w-1/2 bg-cover bg-center relative"
    [style.backgroundImage]="'url(assets/repartidor.png)'"
    >
    <div
      class="absolute inset-0  bg-gray-950/50 flex flex-col justify-end p-12 text-white"
      >
      <h2 class="text-4xl font-bold mb-2">Recupera tu acceso</h2>
      <p class="text-xl">Te enviaremos un enlace para restablecer tu contraseña</p>
    </div>
  </div>

  <!-- Right side - Recovery Form -->
  <div
    class="w-full md:w-1/2 flex items-center justify-center p-8 bg-amber-400 relative"
    style="
      background-image: url('assets/patrones/fondo_patron_subito.webp');
      background-size: 200px 200px;
      background-repeat: repeat;
      background-position: center;
    "
    >
    <div class="w-full max-w-2xl bg-white rounded-4xl shadow-lg p-8">
      <div class="text-center mb-10">
        <div class="flex justify-center mb-4">
          <a [routerLink]="['/']">
            <figure>
              <img
                src="assets/logo/logo_full.png"
                alt="Logo"
                class="h-20 w-auto"
                />
              </figure>
            </a>
          </div>
          <p class="text-gray-600 mt-2">Delivery instantáneo a tu puerta</p>
        </div>

        <h2 class="text-2xl font-bold text-gray-800 mb-6">Recuperar contraseña</h2>

        <form [formGroup]="recoveryForm" (ngSubmit)="onSubmit()" class="space-y-6">
          <!-- Email Field -->
          <div>
            <label
              for="email"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Email</label
              >
              <input
                type="email"
                id="email"
                formControlName="email"
                class="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
            [ngClass]="{
              'border-red-500':
                email?.invalid && (email?.dirty || email?.touched)
            }"
                placeholder="tu@email.com"
                />
                @if (email?.invalid && (email?.dirty || email?.touched)) {
                  <div
                    class="text-red-500 text-sm mt-1"
                    >
                    @if (email?.errors?.['required']) {
                      <div>El email es requerido</div>
                    }
                    @if (email?.errors?.['email']) {
                      <div>
                        Por favor ingresa un email válido
                      </div>
                    }
                  </div>
                }
              </div>

              <!-- Submit Button -->
              <button
                type="submit"
                [disabled]="recoveryForm.invalid || isLoading"
                class="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-white bg-amber-500 hover:bg-amber-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                >
                @if (!isLoading) {
                  <span class="flex items-center">
                    Enviar enlace
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 ml-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      >
                      <path
                        fill-rule="evenodd"
                        d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                        />
                      </svg>
                    </span>
                  }
                  @if (isLoading) {
                    <span class="flex items-center">
                      <svg
                        class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        >
                        <circle
                          class="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          stroke-width="4"
                        ></circle>
                        <path
                          class="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Procesando...
                    </span>
                  }
                </button>
              </form>

              <!-- Login Link -->
              <div class="text-center mt-6">
                <p class="text-sm text-gray-600">¿Ya tienes una cuenta?</p>
                <a
                  [routerLink]="['/auth/login']"
                  class="text-amber-500 hover:text-amber-600 font-medium cursor-pointer"
                  >Iniciar sesión</a
                  >
                </div>

                <!-- Footer -->
                <div class="text-center text-xs text-gray-500 mt-10">
                  © 2025 Subito. Todos los derechos reservados.
                </div>
              </div>
            </div>
          </div>
